import React from 'react';
import PropTypes from 'prop-types';

import Formsy from 'formsy-react';

import {Row, Col, Table, Button, Alert} from 'reactstrap';
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";

import Navigation from "components/Navigation";
import Loading from "components/Loading";

import PrerecordedMessageItem from './PrerecordedMessageItem';

class PrerecordedMessages extends React.Component {
    static propTypes = {
        prerecordedMessages: PropTypes.arrayOf(PropTypes.object).isRequired,
        operator: PropTypes.object.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        onLogout: PropTypes.func.isRequired,
        formStatus: PropTypes.shape({
            type: PropTypes.string.isRequired,
            message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        }),
        formProcessing: PropTypes.bool,
        onFormSubmit: PropTypes.func.isRequired,
    };

    render() {
        const {prerecordedMessages, operator,
                onOnlineChange, onLogout,
                formStatus, formProcessing, onFormSubmit} = this.props;

        return (
            <Row>
                <Col md={4} xl={3} className="col-sidebar">
                    <Navigation user={operator} onOnlineChange={onOnlineChange} onLogout={onLogout}/>
                </Col>
                <Col md={8} xl={9}>
                    <h2 className="mb-3 font-weight-normal text-center pt-3">
                        <FormattedMessage id="prerecorded_messages.page_title" defaultMessage="Prerecorded messages' settings"/>
                    </h2>

                    {prerecordedMessages.length > 0 &&
                        <Formsy onSubmit={onFormSubmit} className="form">
                            <div className="text-center">
                                <FormattedHTMLMessage id="prerecorded_messages.how_to_add" defaultMessage="If you want to record your own busy message please call 234 497 025 from the telephone number that you have set up to receive calls."/>
                            </div>

                            <Table className="table-prerecorded-messages">
                                <thead>
                                <tr>
                                    <th><FormattedMessage id="prerecorded_messages.template" defaultMessage="Type"/></th>
                                    <th><FormattedMessage id="prerecorded_messages.active" defaultMessage="Active?"/></th>
                                </tr>
                                </thead>
                                <tbody>
                                {prerecordedMessages.map((prerecordedMessage) => {
                                    return <PrerecordedMessageItem key={prerecordedMessage.id} name={`${prerecordedMessage.id}`} value={prerecordedMessage.active} prerecordedMessage={prerecordedMessage} />
                                })}
                                </tbody>
                            </Table>

                            {formStatus && !formProcessing &&
                            <Alert color={formStatus.type}>
                                {formStatus.message}
                            </Alert>
                            }

                            <Button type="submit"
                                    className="btn-clickable" block>
                                {formProcessing &&
                                <span className="pr-3">
                                    <Loading inline small/>
                                </span>
                                }
                                <FormattedMessage id="prerecorded_messages.form.submit" defaultMessage="Change password"/>
                            </Button>
                        </Formsy>
                    }
                    {prerecordedMessages.length === 0 &&
                        <p className="text-center">
                            <FormattedHTMLMessage id="prerecorded_messages.empty"/>
                        </p>
                    }
                </Col>
            </Row>
        );
    }
}

export default PrerecordedMessages;


// WEBPACK FOOTER //
// ./src/containers/PrerecordedMessages/PrerecordedMessages.jsx